import * as React from 'react';

const Sort = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={21} {...props}>
        <defs>
            <filter id="sort_a" width="387%" height="512.5%" x="-143.5%" y="-168.8%" filterUnits="objectBoundingBox">
                <feOffset dy={24} in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={40} />
                <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    result="shadowMatrixOuter1"
                    values="0 0 0 0 0.229949097 0 0 0 0 0.461254077 0 0 0 0 0.62647192 0 0 0 0.0533333333 0"
                />
                <feOffset dy={16} in="SourceAlpha" result="shadowOffsetOuter2" />
                <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation={12} />
                <feComposite in="shadowBlurOuter2" in2="SourceAlpha" operator="out" result="shadowBlurOuter2" />
                <feColorMatrix
                    in="shadowBlurOuter2"
                    result="shadowMatrixOuter2"
                    values="0 0 0 0 0.231372549 0 0 0 0 0.462745098 0 0 0 0 0.62745098 0 0 0 0.0266666667 0"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1" />
                    <feMergeNode in="shadowMatrixOuter2" />
                </feMerge>
            </filter>
            <rect id="sort_b" width={92} height={64} x={192} y={0} rx={8} />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g transform="translate(-227 -12)">
                <use xlinkHref="#sort_b" fill="currentColor" filter="url(#sort_a)" />
                <rect width={91} height={63} x={192.5} y={0.5} stroke="#EBEBEB" strokeLinejoin="miter" rx={8} />
            </g>
            <text
                fill="#212A36"
                fontFamily="Manrope_SemiBold, Manrope"
                fontSize={12}
                fontWeight={500}
                transform="translate(-227 -12)"
            >
                <tspan x={212.476} y={44}>
                    Sorteren
                </tspan>
            </text>
            <g
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                transform="translate(1 1)"
            >
                <path d="M15.625 16.2V3m-3.75 9.6 3.308 3.424a.64.64 0 0 0 .442.176.64.64 0 0 0 .442-.176l3.308-3.424" />
                <rect width={7.5} height={7.2} x={0.625} y={0.6} rx={1} />
                <path d="M1.875 18.6c-.69 0-1.25-.537-1.25-1.2m0-4.8c0-.663.56-1.2 1.25-1.2m5 7.2c.69 0 1.25-.537 1.25-1.2m0-4.8c0-.663-.56-1.2-1.25-1.2M3.75 18.6H5m-1.25-7.2H5m-4.375 3v1.2m7.5-1.2v1.2" />
            </g>
        </g>
    </svg>
);
export default Sort;
